export const stringEachWordFirstLetterUpperCase = (string) => {
    // console.log(string)
    let formattedString = string.replaceAll("_", " ");
    let words = formattedString.toLowerCase().split(" ");
    let finalString = words.map((word) => `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`)
        .join(" ");
    return finalString;
};